export const PAYMENT_METHOD_SUBTITLE = `Add a Capital One credit card to pay your remaining balance | `;
export const PAYMENT_METHOD_SUBTITLE_AMOUNT = (amountDue: string) =>
  `Amount due: ${amountDue}`;
